"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldUpdateInputState = shouldUpdateInputState;
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
function shouldUpdateInputState(currentValue, newValue) {
  return !(0, _isEqual2.default)(currentValue, newValue) && !((0, _isEmpty2.default)(currentValue) && (0, _isEmpty2.default)(newValue));
}